import React from 'react';
import { useTranslation } from 'react-i18next';
import './LoadingSpinner.css';

interface LoadingSpinnerProps {
  size?: 'small' | 'medium' | 'large';
  message?: string;
  overlay?: boolean;
}

/**
 * Loading Spinner Component
 * Provides visual feedback during loading operations
 */
export const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({ 
  size = 'medium', 
  message,
  overlay = false 
}) => {
  const { t } = useTranslation();
  const containerClass = `loading-spinner ${overlay ? 'loading-spinner--overlay' : ''}`;
  const spinnerClass = `loading-spinner__spinner loading-spinner__spinner--${size}`;

  return (
    <div className={containerClass} role="status" aria-live="polite">
      <div className={spinnerClass} aria-hidden="true"></div>
      {message && (
        <div className="loading-spinner__message">
          {message}
        </div>
      )}
      <span className="sr-only">{t('loadingSpinner.loading')}</span>
    </div>
  );
};